// extracted by mini-css-extract-plugin
module.exports = {"installServiceCart":"InstallationService_installServiceCart__jSPJA"};